import _ from 'lodash'
import { selectForm } from '../../redux/selectForm'
import {
	AnyConceptStatusesByCid,
	DraftExportSupplement,
	RenderPlatform,
} from '@fusion-advantage/backcompat'
import {
	getConceptStatusValue,
	formOpenPageIdx,
	LeaveBehindConcept,
	proposeFormClinicianScanLeaveBehindIfEmpty,
} from '@fusion-advantage/formlib'
import { setExplicitConceptStatuses, setLeaveBehindDialogOpen, setPageIdx } from '../../redux/formSlice'
import { FormThunk } from '../../redux/formStore'
import { setFormModelDrugIcd } from '../../redux/formModelSlice'
import { useFormAppRelay } from '../relay/FormAppRelay'
import { createCalcs } from '../calc3/createCalcsThunk'
import { runInitialCalculations } from '../../redux/formAssertion3Mw'
import { setCalcEnabled } from '../../redux/calcSlice'
import { createPersisters } from '../formmodel/createPersisters'
import { createDiagnosisItemsFromInputs } from '../../redux/diagnosisReviewInputMw'

export const loadExport = (draftExportSupplement?: DraftExportSupplement): FormThunk<Promise<boolean>> => async (dispatch, getState, { calcMw, persistMw }) => {
	const state = getState()
	const form = state.render.form
	const exp = form?.export
	if(!form || !exp) {
		const message = '[loadExport] Error: attempted to load null export'
		alert(message)
		debugger
		throw new Error(message)
	}
	if(!form?.export?.Form.ConceptStatuses) {
		const message = '[loadExport] Error: no ConceptStatuses on Export'
		alert(message)
		debugger
		throw new Error(message)
	}
	dispatch(setCalcEnabled(false))
	if(draftExportSupplement) {
		// now handled by DraftImport.ts on save
		// see also DraftExport.ts
		// dispatch(unshiftHistoryEntries(draftExportSupplement.StatusHistory))
		// dispatch(setCalculationErrors(draftExportSupplement.CalculationErrors))
	}
	const formAppRelay = useFormAppRelay()
	try {
		// not particularly efficient to load all drug ICD codes up front,
		// but simplicity is currently key with respect to the sensitivity of
		// diagnosis review table changes, and available dev time;
		// by querying all now and shoving into redux,
		// we can query synchronously from within the renderer
		// i.e. without using asyncResultSlice
		const rDrugIcd = await formAppRelay.selectDrugIcdCodes({})
		dispatch(setFormModelDrugIcd(rDrugIcd.icdCodes))
	} catch(ex) {
		console.error('[loadExport] Error loading drug ICD codes', ex)
		alert('Error loading drug ICD codes; please contact support.')
		return false
	}
	let statusesByCid: AnyConceptStatusesByCid = _.cloneDeep(form.export.Form.ConceptStatuses)
	// it is very important that the model persisters like DiagnosisReview
	// load initial state as provided by the database export before any
	// middleware or calculations start to kick off:
	// specifically we want to ensure that DiagnosisReviewItems are loaded
	// from the export into diagnosisReviewSlice before the
	// diagnosisReviewInput activates and writes a new table from scratch
	persistMw.register(createPersisters())
	const rLoadPersisters = dispatch(persistMw.loadFromStatuses(statusesByCid))
	if(rLoadPersisters.isErr()) {
		// TODO dispatch properly
		console.error('[loadExportThunk load persisters]', rLoadPersisters.error)
		alert(`Logged to console: [loadExportThunk load persisters] ${JSON.stringify(rLoadPersisters.error)}`)
		return false
	}
	const statuses = Object.values(statusesByCid)
	dispatch(setExplicitConceptStatuses(statuses))
	// once form data is loaded
	// we can run the initial calculations once,
	// and then safely enable the calculation engine;
	// see also CalcEngine.runCalculations runType
	calcMw.registry.concepts = selectForm(getState()).concepts
	const rRegister = calcMw.registry.register(dispatch(createCalcs(exp)))
	if(rRegister.isErr()) {
		// TODO dispatch properly
		console.error('[loadExportThunk register calcs]', rRegister.error)
		alert(`Logged to console: [loadExportThunk register calcs] ${JSON.stringify(rRegister.error)}`)
	}
	dispatch(runInitialCalculations())
	dispatch(setCalcEnabled(true))
	dispatch(createDiagnosisItemsFromInputs())
	dispatch(setPageIdx(formOpenPageIdx(exp.Form.Encounter.CodeNext)))
	if(getState().render.platform === RenderPlatform.Native) {
		const leaveBehindStatus = statusesByCid[LeaveBehindConcept.cid]
		if(
			proposeFormClinicianScanLeaveBehindIfEmpty(form.writeMode, exp.Form.Encounter.CodeNext, exp.Form.Encounter.BranchDesignatorV2).isOk() &&
			!getConceptStatusValue(leaveBehindStatus)
		) {
			setTimeout(() => {
				dispatch(setLeaveBehindDialogOpen(true))
			}, 1000)
		}
	}
	return true
}
